// src/components/Link/Link.jsx

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link as ReactRouterLink } from "react-router-dom";

import { NAMESPACE } from "../../namespace";
import "./Link.css";

class Link extends PureComponent {
  static propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    className: PropTypes.string,
    internal: PropTypes.bool,
    target: PropTypes.string,
    text: PropTypes.string,
  };

  static defaultProps = {
    className: "",
    target: "_self",
    internal: false,
  };

  render() {
    const { className, href, internal, ariaLabel, ...props } = this.props;
    const composedClass = `${NAMESPACE}Link ${className}`.trim();
    const content = this.props.text || this.props.children;

    let link;

    if (internal) {
      link = (
        <ReactRouterLink
          className={composedClass}
          to={href}
          aria-label={ariaLabel}
          {...props}>
          {content}
        </ReactRouterLink>
      );
    } else {
      link = (
        <a
          className={composedClass}
          href={href}
          aria-label={ariaLabel}
          {...props}>
          {content}
        </a>
      );
    }

    return link;
  }
}

export default Link;
